import * as ambassadorWixEcomV1Wishlist from './ecom-v1-wishlist-wishlists.http.js';
import * as ambassadorWixEcomV1WishlistTypes from './ecom-v1-wishlist-wishlists.types.js';
import * as ambassadorWixEcomV1WishlistUniversalTypes from './ecom-v1-wishlist-wishlists.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getDefaultWishlist(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomV1WishlistUniversalTypes.GetDefaultWishlistRequest,
  ambassadorWixEcomV1WishlistTypes.GetDefaultWishlistRequest,
  ambassadorWixEcomV1WishlistUniversalTypes.GetDefaultWishlistResponse,
  ambassadorWixEcomV1WishlistTypes.GetDefaultWishlistResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1Wishlist.getDefaultWishlist(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/wishlists/get-default',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addItem(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1WishlistUniversalTypes.AddItemRequest,
  ambassadorWixEcomV1WishlistTypes.AddItemRequest,
  ambassadorWixEcomV1WishlistUniversalTypes.AddItemResponse,
  ambassadorWixEcomV1WishlistTypes.AddItemResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEcomV1Wishlist.addItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/wishlists/add-item',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeItem(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1WishlistUniversalTypes.RemoveItemRequest,
  ambassadorWixEcomV1WishlistTypes.RemoveItemRequest,
  ambassadorWixEcomV1WishlistUniversalTypes.RemoveItemResponse,
  ambassadorWixEcomV1WishlistTypes.RemoveItemResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEcomV1Wishlist.removeItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/wishlists/remove-item',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateWishlistTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1WishlistUniversalTypes.BulkUpdateWishlistTagsRequest,
  ambassadorWixEcomV1WishlistTypes.BulkUpdateWishlistTagsRequest,
  ambassadorWixEcomV1WishlistUniversalTypes.BulkUpdateWishlistTagsResponse,
  ambassadorWixEcomV1WishlistTypes.BulkUpdateWishlistTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1Wishlist.bulkUpdateWishlistTags(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/wishlists/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateWishlistTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1WishlistUniversalTypes.BulkUpdateWishlistTagsByFilterRequest,
  ambassadorWixEcomV1WishlistTypes.BulkUpdateWishlistTagsByFilterRequest,
  ambassadorWixEcomV1WishlistUniversalTypes.BulkUpdateWishlistTagsByFilterResponse,
  ambassadorWixEcomV1WishlistTypes.BulkUpdateWishlistTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1Wishlist.bulkUpdateWishlistTagsByFilter(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/wishlists/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Wishlist as WishlistOriginal,
  WishlistItem as WishlistItemOriginal,
  CatalogReference as CatalogReferenceOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  WishlistItemAdded as WishlistItemAddedOriginal,
  WishlistItemRemoved as WishlistItemRemovedOriginal,
  WishlistTagsModified as WishlistTagsModifiedOriginal,
  GetDefaultWishlistRequest as GetDefaultWishlistRequestOriginal,
  GetDefaultWishlistResponse as GetDefaultWishlistResponseOriginal,
  AddItemRequest as AddItemRequestOriginal,
  AddItemResponse as AddItemResponseOriginal,
  RemoveItemRequest as RemoveItemRequestOriginal,
  RemoveItemResponse as RemoveItemResponseOriginal,
  BulkUpdateWishlistTagsRequest as BulkUpdateWishlistTagsRequestOriginal,
  BulkUpdateWishlistTagsResponse as BulkUpdateWishlistTagsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkUpdateWishlistTagsResult as BulkUpdateWishlistTagsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateWishlistTagsByFilterRequest as BulkUpdateWishlistTagsByFilterRequestOriginal,
  BulkUpdateWishlistTagsByFilterResponse as BulkUpdateWishlistTagsByFilterResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  AddItemApplicationErrors as AddItemApplicationErrorsOriginal,
  BulkUpdateWishlistTagsApplicationErrors as BulkUpdateWishlistTagsApplicationErrorsOriginal,
  BulkUpdateWishlistTagsByFilterApplicationErrors as BulkUpdateWishlistTagsByFilterApplicationErrorsOriginal,
} from './ecom-v1-wishlist-wishlists.types.js';
